define("settings/templates/groups/new", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{action this.cancelGroup this.group}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.groups.new.title"}} />
      <ModalForm @cancel={{modal.close}} @task={{task this.handleSubmit this.group}} as |form|>
        <modal.card-body>
          <form.input
            @autofocus={{true}}
            @label={{t "account.groups.new.label"}}
            @placeholder={{t "account.groups.new.placeholder"}}
            @value={{this.group.name}}
          />
        </modal.card-body>
        <modal.card-footer>
          <form.footer
            @cancelButtonQaClass="qa--accessGroup_cancel_btn"
            @submitButtonQaClass="qa--accessGroup_save_btn"
            @submitButtonText={{t "account.groups.new.button"}}
          />
        </modal.card-footer>
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "0JnnjaDL",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0],[30,0,[\"cancelGroup\"]],[30,0,[\"group\"]]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"account.groups.new.title\"],null]]],null],[1,\"\\n    \"],[8,[39,3],null,[[\"@cancel\",\"@task\"],[[30,1,[\"close\"]],[28,[37,4],[[30,0,[\"handleSubmit\"]],[30,0,[\"group\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"input\"]],null,[[\"@autofocus\",\"@label\",\"@placeholder\",\"@value\"],[true,[28,[37,2],[\"account.groups.new.label\"],null],[28,[37,2],[\"account.groups.new.placeholder\"],null],[30,0,[\"group\",\"name\"]]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"footer\"]],null,[[\"@cancelButtonQaClass\",\"@submitButtonQaClass\",\"@submitButtonText\"],[\"qa--accessGroup_cancel_btn\",\"qa--accessGroup_save_btn\",[28,[37,2],[\"account.groups.new.button\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\"],false,[\"shared/modal\",\"action\",\"t\",\"modal-form\",\"task\"]]",
    "moduleName": "settings/templates/groups/new.hbs",
    "isStrictMode": false
  });
});